import React, { 
    useState, 
    useEffect,
} from "react"

import {
    Col, 
    Row,
} from "react-bootstrap"

import EMETLSegmentedControl from "../EMETLSegmentedControl"

import { 
    NeedsEditor, 
} from "../EMETLTaskCellComponents"

import EMETLAssessmentManager, {
    EMETLPerformanceStepRating, PerformanceStepFlat,
} from "../../../Model/EMETLAssessment.m"

import "./style.css"
import EMETLNavButton from "../EMETLNavButton"

export type EMETLAssessmentDetailsPSProps = {
    step: PerformanceStepFlat,
    needs?: string,
    rating?: EMETLPerformanceStepRating,
    onSave: (psID: number, rating: EMETLPerformanceStepRating, needs: string) => Promise<boolean>,
}
 
const EMETLAssessmentDetailsPS = (props: EMETLAssessmentDetailsPSProps) => {
    const { 
        step: { 
            PerformanceStepName, 
            PerformanceStepSequence, 
            PSID,
        }, 
        needs = "",
        rating = EMETLPerformanceStepRating.GO,
        onSave,
    } = props

    const [currentNeeds, setNeeds] = useState(needs)
    const [selectedNoGo, setSelectedNoGo] = useState(rating)
    
    useEffect(() => {
        if (needs !== currentNeeds)
            setNeeds(needs)
        if (rating !== selectedNoGo)
            setSelectedNoGo(rating)
    }, [needs, rating])

    return (
        <div
            className="details-ps-wrapper border-bottom"
        >
            <Col>
                <div
                    className="details-ps-header"
                >
                
                    <span className="ps-details">
                        <p><span className="bold">PS {PerformanceStepSequence}.</span> {PerformanceStepName}</p>
                    </span>
                    <div
                        className="ps-rating-control"
                    >
                        <EMETLSegmentedControl 
                            wrapperClass="no-go-wrapper" 
                            options={EMETLAssessmentManager.PS_RATINGS} 
                            perform={setSelectedNoGo} 
                            selectedTab={selectedNoGo}
                        />
                    </div>
                </div>
            </Col>
            <Row>
                <div
                    className="save-ui"
                >
                    {
                        selectedNoGo > EMETLPerformanceStepRating.GO && (
                            <NeedsEditor 
                                isTaskNeed={true} 
                                currentNeeds={currentNeeds} 
                                setNeeds={setNeeds} 
                            />
                        )
                    }
                    {
                        (currentNeeds !== needs || selectedNoGo !== rating) && (
                            <EMETLNavButton
                                onClick={async () => {
                                    const resp = await onSave(PSID, selectedNoGo, currentNeeds)
                                    if (!resp)
                                        alert("Error saving performance step data.")
                                }}
                                style={{
                                    alignSelf: "flex-end",
                                }}
                            >
                                Save
                            </EMETLNavButton>
                        )
                    }
                </div>
            </Row>
        </div>
    )
}
 
export default EMETLAssessmentDetailsPS